import { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Layout from "../layout";
// import Login from "../components/login";
import Login from "../components/auth/login/enhancedLogin";
// import Signup from "../components/signup";
import Signup from "../components/auth/signup/enhancedSignup";
import Stripe from "../components/stripe/index";
// import Payment from "../components/payment";
// import Dashbord from "../components/dashbord";
import Dashbord from "../components/enhancedDashboard";
// import Profile from "../components/profile";
import Profile from "../components/admin/enhancedUI/profiles/enhancedProfile";
// import Settings from "../components/settings";
import Settings from "../components/user/accountingAndBilling/settings/enhancedSettings";
// import ChangePassword from "../components/changePassword";
import ProtectedRoutes from "./middleware";
// import Destinations from "../components/destinations";
import Destinations from "../components/user/destinations/enhancedDestinations";
// import LeadSources from "../components/leadSources";
import LeadSources from "../components/user/leadManagement/leadImportJob/enhancedLeadSources";
// import ForgotPassword from "../components/forgotPassword";
import ForgotPassword from "../components/auth/forgotPassword/enhancedForgotPassword";
// import VerifyPassword from "../components/verifyPassword";
import VerifyPassword from "../components/auth/verifyPassword/enhancedVerifyPassword";
// import Autoresponder from "../components/autoresponders";
import Autoresponder from "../components/user/automations/autoresponders/enhancedAutoresponders";
// import AlertEmailSms from "../components/alertEmailSms";
import AlertEmailSms from "../components/user/automations/alerts/enhancedAlerts";
// import CancelSubscription from "../components/cancelSubscription";
import VerifyAccount from "../components/verifyAccount";
// import LeadsImportCsv from "../components/leadsImportCsv";
import LeadsImportCsv from "../components/user/leadManagement/leadImportCsv/enhancedLeadImportViaCSV";

/**
 * ADMIN ROUTES
 */
import AdminUsers from "../components/admin/enhancedUI/users/enhanced-users";
// import PaymentInvoice from "../components/paymentInvoice";
import EnhancedPaymentInvoice from "../components/enhnacedPaymentInvoice";
// import AdminLeadsImported from "../components/admin/leadsImported";
import AdminLeadsImported from "../components/admin/enhancedUI/reports/leads-imported/enhancedLeadsImported";

import AdminCoupons from "../components/admin/enhancedUI/coupons/enhancedCoupons";
// import AdminCouponsOld from "../components/admin/coupons";
import AdminCouponHistory from "../components/admin/enhancedUI/coupons/enhanced-coupon-history";
import AdminAffiliate from "../components/admin/enhancedUI/affliates/enhance-affliates";
// import AdminAffiliate from "../components/admin/affiliate";
// import AdminScrappingErrors from "../components/admin/scrappingErrors";
import AdminScrappingErrors from "../components/admin/enhancedUI/reports/scrapping-errors/enhancedScrappingErrors";
// import AdminEmailLogs from "../components/admin/emailLogs";
import AdminEmailLogs from "../components/admin/enhancedUI/reports/emailLogs/enhancedEmailLogs";
// import AdminCancelledSubscriptions from "../components/admin/cancelledSubscriptions";
import AdminCancelledSubscriptions from "../components/admin/enhancedUI/reports/cancelledSuscriptions/enhancedCancelledSubscriptions";
// import AdminChangeUserEmail from "../components/admin/changeUserEmail";
import AdminChangeUserEmail from "../components/admin/enhancedUI/changeUserEmail/enhancedChangeUserEmail";
// import AdminPaymentHistory from "../components/admin/paymentHistory"; 
import AdminPaymentHistory from "../components/admin/enhancedUI/reports/paymentCustomerWise/enhancedPaymentCustomerWise";
// import AdminZapierAccounts from "../components/admin/zapierAccounts";
import AdminZapierAccounts from "../components/admin/enhancedUI/zapierAccounts/enhancedZapier";
// import AdminDataBaseBackup from "../components/admin/dataBaseBackup";
import AdminDataBaseBackup from "../components/admin/enhancedUI/databaseBackup/enhanceDatabaseBacktup";
// import AdminIncomeReport from "../components/admin/incomeReport";
import AdminIncomeReport from "../components/admin/enhancedUI/reports/paymentMonthwise/enhancedPaymentMonthWise";
// import AdminLowActivityUsers from "../components/admin/lowActivityUsers";
import AdminLowActivityUsers from "../components/admin/enhancedUI/reports/lowActivityUsers/enhancedLowActivityUsers";
import AdminStaticResidentialIps from "../components/admin/enhancedUI/reports/staticResidentialIps/enhancedStaticResidentialIps";

/**
 * ADMIN REPORTS ROUTES
 */
// import NoLeadsSend from "../components/admin/reports/noLeadsSend";
import NoLeadsSend from "../components/admin/enhancedUI/reports/leads-not-sent/enhancedLeadsNotSent";
import NoLeadsSendDetails from "../components/admin/enhancedUI/reports/leads-not-sent/leadNotSentDetails/enhancedLeadNotSentDetails";

/**
 * REPORTS ROUTES
 */
// import LeadsImported from "../components/reports/leadsImported";
import LeadsImported from "../components/user/reports/leadsImported/enhancedLeadsImportedUser";
// import LeadSentHistory from "../components/reports/leadSentHistory";
import LeadSentHistory from "../components/user/reports/leadsSent/enhancedLeadsSent";
// import AutoresponseSent from "../components/reports/autoresponseSent";
import AutoresponseSent from "../components/user/reports/autoresponseSent/enhanceAutoresponseSent";
// import Notificaions from "../components/reports/notifications";
import Notificaions from "../components/user/reports/notifications/enhancedNotifications";
// import PaymentHistory from "../components/reports/paymentHistory";
import PaymentHistory from "../components/user/accountingAndBilling/paymentHistory/enhancedPaymentHistory";
// import Invoices from "../components/reports/invoices";
import Invoices from "../components/user/accountingAndBilling/invoices/enhancedInvoices";
// import LeadsImportedViaCSV from "../components/reports/leadsImportedViaCSV";
import LeadsImportedViaCSV from "../components/user/leadManagement/leadImportCsv/enhancedLeadImportViaCSV";
// import hotLeads from "../components/reports/hotLeads";
import hotLeads from "../components/user/reports/hotLeads/enhancedHotLeads";

// import WebLink from "../components/webLink";
import WebLink from "../components/user/leadManagement/contentRequestForms/enhancedRequestForms";
import LeadGenerateForm from "../components/leadGenerateForm";
// import LeadsImportedViaForm from "../components/reports/leadsImportedViaForm";
import LeadsImportedViaForm from "../components/user/reports/leadsImportedVIaForm/enhancedLeadsImportedViaForm";
// import ActivityLog from "../components/activityLog";
import ActivityLog from "../components/user/reports/activityLog/enhancedActivityLog";
import Affiliate from "../components/affiliate";
import StripeOnBoard from "../components/stripeOnBoard";
// import AffiliateDashboard from "../components/affiliateDashboard";
import AffiliateDashboard from "../components/enhancedAffiliateDashboard";
// import Customers from "../components/reports/AffiliateCustomers";
import Customers from "../components/reports/enhancedAffliatesCustomers";
// import ZapierConfigration from "../components/zapierConfigration";
import ZapierConfigration from "../components/user/automations/zapierIntegration/enhancedZapierIntegration";
import TestAccounts from "../components/admin/TestAccounts";
// import NewLeadAlert from "../components/reports/newLeadAlert";
import NewLeadAlert from "../components/user/reports/newLeadAlert/enhancedNewLeadAlert";

const AppRoutes = () => {
  useEffect(() => {
    document.title = `Leads Import`;
  }, []);
  return (
    <Router>
      <Switch>
        <Route path={"/"} exact>
          {" "}
          <Login />{" "}
        </Route>
        <Route path="/signup">
          <Signup />{" "}
        </Route>
        <Route path="/affiliate">
          <Affiliate />
        </Route>
        <Route path="/signup/trial">
          <Signup />{" "}
        </Route>
        <Route path="/forgotpassword">
          <ForgotPassword />{" "}
        </Route>
        <Route path="/verifypassword">
          <VerifyPassword />{" "}
        </Route>
        <Route path="/verifyaccount">
          <VerifyAccount />{" "}
        </Route>

        <Route path="/stripeonboard">
          <StripeOnBoard />
        </Route>
        <Route path="/stripeOnboardedCompletedAffiliate">
          <StripeOnBoard />
        </Route>
        <Route path="/payment-signup">
          <Stripe />
        </Route>
        <Route path="/weblink/present/webform">
          <LeadGenerateForm />
        </Route>

        {/* <ProtectedRoutes path="/payment" component={Payment} layout={Layout} /> */}
        <ProtectedRoutes
          path="/payment-invoice"
          component={EnhancedPaymentInvoice}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/invoices"
          component={Invoices}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/payment-history"
          component={PaymentHistory}
          layout={Layout}
        />
        {/* <ProtectedRoutes
          path="/leads-imported"
          component={LeadsImported}
          layout={Layout}
          exact
        /> */}
        <ProtectedRoutes
          path="/leads-imported"
          component={LeadsImported}
          layout={Layout}
          exact
        />
        <ProtectedRoutes
          path="/leads-import-csv"
          component={LeadsImportCsv}
          layout={Layout}
        />
        <ProtectedRoutes path="/web-link" component={WebLink} layout={Layout} />

        <ProtectedRoutes
          path="/leads-sent"
          component={LeadSentHistory}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/notifications"
          component={Notificaions}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/autoresponse-sent"
          component={AutoresponseSent}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/activity-log"
          component={ActivityLog}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/new-lead-alert"
          component={NewLeadAlert}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/leads-imported-via-csv"
          component={LeadsImportedViaCSV}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/leads-imported-via-form"
          component={LeadsImportedViaForm}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/hot-leads"
          component={hotLeads}
          layout={Layout}
          exact
        />

        <ProtectedRoutes
          path="/dashboard"
          component={Dashbord}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/dashboard-affiliate"
          component={AffiliateDashboard}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/customers"
          component={Customers}
          layout={Layout}
        />
        <ProtectedRoutes path="/profile" component={Profile} layout={Layout} />
        <ProtectedRoutes
          path="/settings"
          component={Settings}
          layout={Layout}
        />
        {/* <ProtectedRoutes
          path="/changepassword"
          component={ChangePassword}
          layout={Layout}
        /> */}
        <ProtectedRoutes
          path="/zapier-configuration"
          component={ZapierConfigration}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/destinations"
          component={Destinations}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/lead-sources"
          component={LeadSources}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/autoresponders"
          component={Autoresponder}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/alerts"
          component={AlertEmailSms}
          layout={Layout}
        />
        {/* <ProtectedRoutes
          path="/cancel-subscription"
          component={CancelSubscription}
          layout={Layout}
        /> */}

        <ProtectedRoutes
          path="/admin/users"
          component={AdminUsers}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/admin/test-accounts"
          component={TestAccounts}
          layout={Layout}
        />

        <ProtectedRoutes
          path="/admin/leads-imported"
          component={AdminLeadsImported}
          layout={Layout}
        />
        {/* <ProtectedRoutes
          path="/admin/leads-imported/old"
          component={AdminLeadsImportedOld}
          exact
          layout={Layout}
        /> */}
        <ProtectedRoutes
          path="/admin/coupons"
          exact
          component={AdminCoupons}
          layout={Layout}
        />
        {/* <ProtectedRoutes
          path="/admin/coupons/old"
          exact
          component={AdminCouponsOld}
          layout={Layout}
        /> */}
        <ProtectedRoutes
          path="/admin/coupons/usage-history"
          component={AdminCouponHistory}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/admin/affiliate-partners"
          component={AdminAffiliate}
          layout={Layout}
        />
        {/* <ProtectedRoutes
          path="/admin/affiliate/old"
          component={AdminAffiliateOld}
          layout={Layout}
          exact
        /> */}
        <ProtectedRoutes
          path="/admin/zapier-accounts"
          component={AdminZapierAccounts}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/admin/scrapping-errors"
          component={AdminScrappingErrors}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/admin/email-logs"
          component={AdminEmailLogs}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/admin/payment-history"
          component={AdminPaymentHistory}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/admin/cancelled-subscriptions"
          component={AdminCancelledSubscriptions}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/admin/low-activity-users"
          component={AdminLowActivityUsers}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/admin/static-residential-ips"
          component={AdminStaticResidentialIps}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/admin/change-user-email"
          component={AdminChangeUserEmail}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/admin/leads-not-send"
          component={NoLeadsSend}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/admin/lead-not-send-details"
          component={NoLeadsSendDetails}
          layout={Layout}
          exact
        />
        <ProtectedRoutes
          path="/admin/database-backup"
          component={AdminDataBaseBackup}
          layout={Layout}
        />
        <ProtectedRoutes
          path="/admin/income-report"
          component={AdminIncomeReport}
          layout={Layout}
        />
      </Switch>
    </Router>
  );
};

export default AppRoutes;
